import { Entities } from '../../store';
import { WebsocketProjectEvent } from '../../websocket';
import {
  NavigationProjectFeedApiResponse,
  NavigationProjectFeedItem,
  NavigationProjectFeedItemApiResponse,
} from './project-feed.model';

// This takes an API response and transforms it into a NavigationProjectFeed object
export function transformNavigationProjectFeedItem(
  item: NavigationProjectFeedItemApiResponse,
): Entities<NavigationProjectFeedItem> {
  return {
    [`${item.type}-${item.id}`]: {
      id: item.id,
      appendedDescr: item.appended_descr,
      currency: item.currency,
      currencyCode: item.currencyCode,
      exchangerate: item.exchangerate,
      featured: item.featured,
      freeBidUntil: item.free_bid_until,
      fulltime: item.fulltime,
      // hidebids: item.hidebids,
      imgUrl: item.imgUrl,
      isMinimallyPostedProject: item.isMinimallyPostedProject,
      jobs: item.jobs.map(job => Number(job)),
      jobString: item.jobString,
      linkUrl: item.linkUrl,
      maxbudget: Number(item.maxbudget),
      minbudget: Number(item.minbudget),
      minimallyPostedProjectBudgetSet: item.minimallyPostedProjectBudgetSet,
      nonpublic: item.nonpublic,
      projIsHourly: item.projIsHourly,
      showBudgetMinimallyPostedProject: item.showBudgetMinimallyPostedProject,
      submitDate: item.submitDate,
      text: item.text,
      time: item.time * 1000, // Turns seconds to miliseconds
      title: item.title,
      type: item.type,
      userId: Number(item.userId),
      userName: item.userName,
    },
  };
}

// This takes an API response and transforms it into a NavigationProjectFeed object
export function transformNavigationProjectFeedItems(
  items: NavigationProjectFeedApiResponse,
): Entities<NavigationProjectFeedItem> {
  if (items) {
    return items.reduce(
      (acc, item) => ({
        ...acc,
        ...transformNavigationProjectFeedItem(item),
      }),
      {},
    );
  }
  return {};
}

export function transformNavigationProjectFeedWS(
  item: WebsocketProjectEvent['data'],
): Entities<NavigationProjectFeedItem> {
  return {
    [`project-${item.id}`]: {
      id: item.id,
      appendedDescr: item.appended_descr,
      currency: item.currency,
      currencyCode: item.currencyCode,
      exchangerate: item.exchangerate,
      featured: item.featured,
      freeBidUntil: item.free_bid_until,
      fulltime: item.fulltime,
      imgUrl: item.imgUrl,
      isMinimallyPostedProject: item.isMinimallyPostedProject,
      jobs: item.jobs.map(job => Number(job)),
      jobString: item.jobString,
      linkUrl: item.linkUrl,
      maxbudget: Number(item.maxbudget),
      minbudget: Number(item.minbudget),
      minimallyPostedProjectBudgetSet: item.minimallyPostedProjectBudgetSet,
      nonpublic: item.nonpublic,
      projIsHourly: item.projIsHourly,
      showBudgetMinimallyPostedProject: item.showBudgetMinimallyPostedProject,
      submitDate: item.submitDate,
      text: item.text,
      time: item.time * 1000, // Turns seconds to miliseconds
      title: item.title,
      type: 'project',
      userId: Number(item.userId),
      userName: item.userName,
    },
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/navigation/project-feed/project-feed.transformers.ts